export const STEPS = [
  "Riepilogo",
  "Dati",
  "Lavoro",
  "Beneficiario",
  "Questionario",
  "Conferma",
];

export const INITIAL_FORM_DATA = {
  nome: "",
  cognome: "",
  dataNascita: "",
  sesso: "",
  email: "",
  telefono: "",
  privacyAccepted: false,
  statusLavorativo: "",
  hasBeneficiario: false,
  nomeBeneficiario: "",
  cognomeBeneficiario: "",
  relazioneBeneficiario: "",
  emailBeneficiario: "",
  telefonoBeneficiario: "",
  // Questionario
  consapevolezzaScoperti: false,
  comprensioneRinnovo: false,
  protezioneStandard: false,
  protezionePotenziata: false,
  condizioniGenerali: false,
  condizioniVendita: false,
  comunicazioniCommerciali: false,
};

export const RELAZIONI_BENEFICIARIO = [
  { value: "coniuge", label: "Coniuge" },
  { value: "figlio", label: "Figlio/a" },
  { value: "genitore", label: "Genitore" },
  { value: "fratello", label: "Fratello/Sorella" },
  { value: "partner", label: "Partner" },
  { value: "altro", label: "Altro" },
];

export const STATUS_LAVORATIVO = [
  { value: "autonomo", label: "Lavoratore autonomo" },
  { value: "dipendente_privato", label: "Lavoratore dipendente privato" },
  { value: "dipendente_pubblico", label: "Lavoratore dipendente pubblico" },
  { value: "tempo_determinato", label: "Contratto a tempo determinato" },
  { value: "non_lavoratore", label: "Non lavoratore" },
];

export const PREMIO_ANNUALE = 130;

export const COPERTURE = {
  standard: {
    deccessoAccidentale: 50000,
  },
  potenziata: {
    invaliditaPermanente: 50000,
    inabilitaTemporanea: 1000,
  },
  comuni: {
    protezioneBollette: 1000,
    protezioneReddito: 1000,
    assistenzaLegale: true,
  },
};
